import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Listings from "@/components/Listings";
import MarketInsights from "@/components/MarketInsights";
import Blogs from "@/components/Blogs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-[#f5f0e8] text-[#1c1c1c]">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Listings />
      <MarketInsights />
      <Blogs />
      <Contact />
      <Footer />
      <Chatbot />
    </main>
  );
}
